<!-- ═══════════════ STAKE & PORTFOLIO SIDE BY SIDE PROMOS ═══════════════ -->
<section class="max-w-[1320px] mx-auto px-6 lg:px-10 pb-12">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

    <!-- Stake Tokens Promo -->
    <div
      class="promo-card p-8 flex flex-col-reverse md:flex-row items-center justify-between gap-8 md:gap-4 overflow-hidden transition-all duration-300 hover:shadow-[0_10px_40px_rgba(245,183,59,0.15)] hover:border-gold/30 cursor-pointer">
      <div class="flex flex-col items-center md:items-start text-center md:text-left gap-4 z-10">
        <h3 class="font-display font-black text-xl text-white uppercase tracking-wider leading-none">
          {{ stakeBanner().title }}
        </h3>
        <p class="text-text-muted text-[13px] max-w-[280px] leading-relaxed font-medium">
          {{ stakeBanner().description }}
        </p>
        <button (click)="router.navigate(['/staking'])"
          class="btn-gold px-6 py-3 rounded-xl text-[11.5px] font-bold tracking-widest uppercase shadow-md">Stake
          Assets</button>
      </div>
      <div class="shrink-0 md:-mr-6 md:-mb-4 stake-img-blend relative">
        <!-- Gold Sparkles Outer Circle -->
        <div
          class="absolute z-0 flex items-center justify-center animate-[spin_15s_linear_infinite] pointer-events-none"
          style="width: 150px; height: 150px; left: 0; right: 0; margin: 0 auto; bottom: 5px;">
          <!-- Sparkle Shapes -->
          <svg class="absolute -top-2 right-6 w-3 h-3 text-gold drop-shadow-[0_0_8px_rgba(245,183,59,1)]"
            fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 0l2.5 8.5L23 11l-8.5 2.5L12 22l-2.5-8.5L1 11l8.5-2.5z" />
          </svg>
          <svg class="absolute bottom-1 left-4 w-2 h-2 text-gold drop-shadow-[0_0_6px_rgba(245,183,59,1)]"
            fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 0l2.5 8.5L23 11l-8.5 2.5L12 22l-2.5-8.5L1 11l8.5-2.5z" />
          </svg>
          <!-- Dots -->
          <div class="absolute top-8 -right-2 bg-gold rounded-full shadow-[0_0_6px_1px_rgba(245,183,59,0.8)]"
            style="width: 1px; height: 1px;"></div>
          <div class="absolute bottom-6 -right-1 bg-gold rounded-full shadow-[0_0_4px_1px_rgba(245,183,59,0.8)]"
            style="width: 0.5px; height: 0.5px;"></div>
          <div class="absolute top-1/2 -left-3 bg-gold rounded-full shadow-[0_0_6px_1px_rgba(245,183,59,0.8)]"
            style="width: 1px; height: 1px;"></div>
          <div class="absolute top-2 left-8 bg-gold rounded-full shadow-[0_0_4px_1px_rgba(245,183,59,0.8)]"
            style="width: 0.5px; height: 0.5px;"></div>
        </div>
        <img src="/logo.png" alt="Stake Tokens"
          class="h-28 w-auto object-contain relative z-10 drop-shadow-[0_0_25px_rgba(245,183,59,0.5)]" />
      </div>
    </div>

    <!-- Portfolio Connect Promo -->
    <div
      class="promo-card-gold p-8 flex flex-col-reverse md:flex-row items-center justify-between gap-8 md:gap-4 overflow-hidden transition-all duration-300 hover:shadow-[0_10px_40px_rgba(245,183,59,0.25)] hover:border-gold/30 cursor-pointer">
      <div class="flex flex-col items-center md:items-start text-center md:text-left gap-4 z-10">
        <h3 class="font-display font-black text-xl text-white uppercase tracking-wider leading-none">
          {{ walletBanner().title }}
        </h3>
        <p class="text-text-muted text-[13px] max-w-[280px] leading-relaxed font-medium">
          {{ walletBanner().description }}
        </p>
        @if (isClient()) {
        <button (click)="state.isWalletConnected() ? state.selectNav('portfolio') : state.openConnectModal()"
          class="btn-gold px-6 py-3 rounded-xl text-[11.5px] font-bold tracking-widest uppercase shadow-md">
          {{ state.isWalletConnected() ? 'View Portfolio' : 'Connect Wallet' }}
        </button>
        } @else {
        <button
          class="btn-gold px-6 py-3 rounded-xl text-[11.5px] font-bold tracking-widest uppercase shadow-md">
          Connect Wallet
        </button>
        }
      </div>
      <div class="shrink-0 md:-mr-6 md:-mb-4 stake-img-blend">
        <img src="/wallet.png" alt="Wallet Cockpit" class="h-36 w-auto object-contain img-knockout-black" />
      </div>
    </div>

  </div>
</section>

<!-- ═══════════════ TRUST & AUDIT BADGES SECTION ═══════════════ -->
<section class="max-w-[1320px] mx-auto px-6 lg:px-10 pb-16">
  <div class="text-center mb-10 lg:mb-12">
    <h2 class="font-display font-black text-2xl text-white uppercase tracking-wider flex flex-col items-center gap-4">
      Built for everyone. Secured by the best.
      <span class="w-16 h-1 bg-gold rounded-full shadow-[0_0_10px_rgba(245,183,59,0.5)]"></span>
    </h2>
  </div>

  <div class="card p-6 md:p-8 rounded-[20px] bg-[#0c0c0c]/80 border border-gold/20 shadow-[0_8px_30px_rgba(0,0,0,0.5)]">
    <div class="grid grid-cols-1 tablet:grid-cols-2 desktop:grid-cols-4 gap-6 desktop:gap-0 desktop:divide-x divide-white/10">
      
      <!-- Feature 1 -->
      <div class="flex items-center gap-4 desktop:px-6 desktop:first:pl-0 desktop:last:pr-0">
        <div class="w-14 h-14 rounded-full border border-gold/40 bg-gold/10 flex items-center justify-center text-gold shadow-[0_0_20px_rgba(245,183,59,0.15)] shrink-0">
          <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
          </svg>
        </div>
        <div class="flex flex-col">
          <h3 class="font-display font-bold text-white text-[18px] tracking-wide">{{ features()[0]?.title }}</h3>
          <p class="text-[#999999] text-[14px] mt-1.5 leading-relaxed font-normal">{{ features()[0]?.description }}</p>
        </div>
      </div>

      <!-- Feature 2 -->
      <div class="flex items-center gap-4 desktop:px-6 desktop:first:pl-0 desktop:last:pr-0">
        <div class="w-14 h-14 rounded-full border border-gold/40 bg-gold/10 flex items-center justify-center text-gold shadow-[0_0_20px_rgba(245,183,59,0.15)] shrink-0">
          <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 14.25l6-6m-4.5 6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm6-4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
          </svg>
        </div>
        <div class="flex flex-col">
          <h3 class="font-display font-bold text-white text-[18px] tracking-wide">{{ features()[1]?.title }}</h3>
          <p class="text-[#999999] text-[14px] mt-1.5 leading-relaxed font-normal">{{ features()[1]?.description }}</p>
        </div>
      </div>

      <!-- Feature 3 -->
      <div class="flex items-center gap-4 desktop:px-6 desktop:first:pl-0 desktop:last:pr-0">
        <div class="w-14 h-14 rounded-full border border-gold/40 bg-gold/10 flex items-center justify-center text-gold shadow-[0_0_20px_rgba(245,183,59,0.15)] shrink-0">
          <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z" />
          </svg>
        </div>
        <div class="flex flex-col">
          <h3 class="font-display font-bold text-white text-[18px] tracking-wide">{{ features()[2]?.title }}</h3>
          <p class="text-[#999999] text-[14px] mt-1.5 leading-relaxed font-normal">{{ features()[2]?.description }}</p>
        </div>
      </div>

      <!-- Feature 4 -->
      <div class="flex items-center gap-4 desktop:px-6 desktop:first:pl-0 desktop:last:pr-0">
        <div class="w-14 h-14 rounded-full border border-gold/40 bg-gold/10 flex items-center justify-center text-gold shadow-[0_0_20px_rgba(245,183,59,0.15)] shrink-0">
          <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
          </svg>
        </div>
        <div class="flex flex-col">
          <h3 class="font-display font-bold text-white text-[18px] tracking-wide">{{ features()[3]?.title }}</h3>
          <p class="text-[#999999] text-[14px] mt-1.5 leading-relaxed font-normal">{{ features()[3]?.description }}</p>
        </div>
      </div>

    </div>
  </div>
</section>